import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'

export default function TreatmentProcessSection() {
    return (
        <div className='treatment-process-section'>
            <div className='d-flex justify-content-between treatment-process row mx-0'>
                <div className='treatment-process-details col col-12'>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <h3 style={{ fontSize: '3em', fontWeight: '800', textAlign: 'start' }}>3 stage treatment<br />process</h3>
                    </AnimationOnScroll>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.5em', fontWeight: '500' }}>
                            Kaptain Ply's 3 stage treatment helps in<br />
                            making the plywood non hazardous, and<br />
                            thus optimizes the quality and reliability<br />
                            of the plywood.</p>
                    </AnimationOnScroll>
                </div>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='treatment-process-card mt-4 mt-md-0' style={{ background: '#888895' }}>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.5em', fontWeight: '500' }}>
                            Each layer of core veneer will go through rigorous chemical treatment in boiling water before drying.
                        </p>
                    </AnimationOnScroll>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='treatment-process-card  mt-4 mt-md-0' style={{ background: '#F5AE2A' }}>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.5em', fontWeight: '500' }}>
                            Our Glue line treatment makes the ply borer proof and long-lasting.
                        </p>
                    </AnimationOnScroll>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='treatment-process-card  mt-4 mt-md-0' style={{ background: '#EA2037' }}>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.5em', fontWeight: '500' }}>
                            Final treatment of plywood after quality check ensures the durability of the product.
                        </p>
                    </AnimationOnScroll>
                </AnimationOnScroll>
            </div>
            <div className='technology-section d-flex flex-column align-items-center justify-content-center'>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">

                    <h3 style={{ fontSize: '3em', fontWeight: '800' }}> High end 4 Press <br />Technology</h3>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <p style={{ fontSize: '1.5em', fontWeight: '800' }}>Delivering fine and precise plywood through our<br />
                        Hot-Cold press technique that makes the product<br />
                        structurally balanced while maintaining impressive<br />
                        density throughout the corners.</p>
                </AnimationOnScroll>
            </div>
        </div >
    )
}
